import moment from "moment";
import APIVariables from "../../../../services/api-variables";
import Axios from "../../../../services/Axios";
import { handleCatch } from "../../../../shared/helpers";

function parseNumeric(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number" && !Number.isNaN(value)) return value;
  const match = String(value).match(/\d+(?:\.\d+)?/);
  return match ? parseFloat(match[0]) : null;
}

/** Read-only labels for PAF History rows (patient list summary from GET /patients/{id}/). */
export function historyIndicationLabel(p) {
  if (p == null || p.indication == null) return "—";
  if (typeof p.indication === "string") {
    if (p.indication.includes("Other")) {
      return `Other (${p.indication_other ?? ""})`;
    }
    if (p.indication.includes("Clinical trial")) {
      return `Clinical Trial (${p.clinical_trial ?? ""})`;
    }
    return p.indication;
  }
  return "—";
}

export function historyDispensingDate(p) {
  const st = p?.status_name ?? p?.status;
  if (st !== "Dispensed") return "—";
  const d = p?.dispensed_date;
  return d ? moment(d).format("DD-MMM-YYYY").toUpperCase() : "—";
}

export function historyPafDate(p) {
  return p?.pfa_issued
    ? moment(p.pfa_issued).format("DD-MMM-YYYY").toUpperCase()
    : "—";
}

export function historyMoleculeLabel(p) {
  if (typeof p?.molecule === "string") return p.molecule;
  return "—";
}

export function historyDosageStrength(p) {
  const summaryStrength = p?.total_capsule_strength;
  if (
    summaryStrength == null ||
    summaryStrength === "" ||
    summaryStrength === "0"
  ) {
    return "—";
  }
  const n = String(summaryStrength).trim();
  return /mg$/i.test(n) ? n : `${n}mg`;
}

export function historyCapsules(p) {
  const n = parseNumeric(p?.n_capsules ?? p?.total_capsules);
  if (n == null) return "—";
  return `${n} ${n === 1 ? "capsule" : "capsules"}`;
}

export function historyWeeksPerCycle(p) {
  if (p?.schedule_display_type !== "weeks_per_cycle") return "—";
  if (p?.n_weeks_other != null && p.n_weeks_other !== "") {
    return `${p.n_weeks_other} weeks`;
  }
  if (p?.n_weeks != null && p.n_weeks !== "" && p.n_weeks !== 0) {
    return `${p.n_weeks} weeks`;
  }
  return "—";
}

export function historyNCycles(p) {
  const cycles = parseNumeric(p?.n_cycles);
  if (cycles == null) return "—";
  return `${cycles} ${cycles === 1 ? "cycle" : "cycles"}`;
}

export function historyTotalSupplyWeeks(p) {
  const v = p?.total_weeks_supply;
  if (v == null || v === "" || v === 0) return null;
  const n = String(v).trim();
  return /weeks?$/i.test(n) ? n : `${n} weeks`;
}

export function downloadPafPdfForPatient(patientId, filenameBase) {
  if (!patientId) return Promise.resolve();
  return Axios.get(APIVariables.DOWNLOAD_PAF + patientId)
    .then((response) => response.data.report)
    .then(async (base64) => {
      const base64Pdf = await fetch(`data:application/pdf;base64,${base64}`);
      return base64Pdf.blob();
    })
    .then((blob) => {
      const file = new Blob([blob], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileURL;
      downloadLink.download = `${filenameBase || "PAF"}.pdf`;
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(fileURL);
    })
    .catch((error) => {
      handleCatch(error);
    });
}
